
const instance = {
    baseURL: 'https://openexchangerates.org/api/latest.json',
    api_key: '0448eb485bd544609a3b187501fb47ed',
}

export const rateApi = {
    getRate(base) {
        return fetch(`${instance.baseURL}?app_id=${instance.api_key}&base=${base}`)
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                return Promise.reject('Something is wrong');
            })
    }
}